import { Pagination } from "@mui/material";
import { FC } from "react";
import { useFormContext } from "react-hook-form";

import { IRichLogsFilter, RichLogFormFields } from "./rich-logs.models";
import { RichLogsPaginationContainerStyled } from "./rich-logs.styled";

interface IRichLogsPagination {
  totalPages: number;
  currentPage: number;
}

export const RichLogsPagination: FC<IRichLogsPagination> = ({
  totalPages,
  currentPage,
}) => {
  const { setValue } = useFormContext<IRichLogsFilter>();

  const handlePageChange = (
    _: React.ChangeEvent<unknown>,
    value: number,
  ): void => {
    setValue(RichLogFormFields.page, value);
  };

  if (totalPages <= 1) {
    return null;
  }

  return (
    <RichLogsPaginationContainerStyled>
      <Pagination
        size="small"
        page={currentPage}
        count={totalPages}
        onChange={handlePageChange}
        showFirstButton
        showLastButton
      />
    </RichLogsPaginationContainerStyled>
  );
};
